// 9fbef606107a605d69c0edbcd8029e5d
import getBOPISInventory from '@tcp/core/src/queries/getBopisProductInventoryDetails.query.graphql';
import getStoreInventory from '@tcp/core/src/queries/getStoreInventoryDetails.query.graphql';
import logger from '@tcp/core/src/utils/loggerInstance';
import { graphQlErrorHandler } from '@tcp/core/src/utils/errorMessage.util';
import { executeStatefulGraphQLQuery } from '../../../handler';

const formPayload = (param) => {
  let payload = param;

  if (Array.isArray(param)) {
    payload = {
      productIds: param.map((item) => item.itemPartNumber),
      storeIds: param[0]?.storeId,
    };
  }
  return payload;
};

const processResponse = (resp, isStoreInventoryApiEnabled) => {
  const inventoryDataObj = isStoreInventoryApiEnabled ? 'getStoreInventory' : 'getBOPISInventory';
  const inventoryDataVal = isStoreInventoryApiEnabled ? 'storeInventory' : 'bopisInventory';
  const inventory = resp?.data?.[inventoryDataObj]?.[inventoryDataVal] || [];
  return (
    (inventory &&
      Array.isArray(inventory) &&
      inventory.length &&
      inventory.map((item) => {
        return {
          variantNo: item.itemName.toString(),
          quantity: item.atcQuantity,
          status: item.atcStatus,
          storeId: item.facilityName.toString(),
          productID: item.itemName.toString(),
        };
      })) ||
    []
  );
};

const simplifyResult = (bopisItems, result) => {
  if (Array.isArray(bopisItems)) {
    return result.filter((backendResult) => {
      return bopisItems.find(
        (item) =>
          bopisItems[0].itemPartNumber === backendResult.productID &&
          item.storeId === backendResult.storeId
      );
    });
  }
  return result;
};
/**
 * @function getBopisInventoryDetails
 * @summary This API is used get the BOPIS inventory on load of mini bag drawer or my bag page.
 * @param {String[]} storeIds - List of storeIds present in the cart.
 * @param {String[]} variantNumbers - List of variantNumbers for BOPIS items present in the cart.
 * @return {Object[]} Each object contains the inventory count and status for BOPIs items in the cart.
 * @example  getBopisInventoryDetails().then((resp) =>
 * console.log(res);
 * [
      {
        variantNo: '1111',
        quantity: 0,
        status: 'In Stock'
      }
    ]
  );
  */
// re write this method split into two parts , use for another payload to check
const getBopisInventoryDetails = (
  bopisItems,
  errorsMapping = [],
  isStoreInventoryApiEnabled,
  isMultiStoreEnabled = false
) => {
  const queryPayload = formPayload(bopisItems);
  const payload = {
    query: isStoreInventoryApiEnabled ? getStoreInventory : getBOPISInventory,
    variables: queryPayload,
    fetchPolicy: 'no-cache',
    type: 'query',
  };

  return executeStatefulGraphQLQuery(payload)
    .then((res) => {
      const backendResults = processResponse(res, isStoreInventoryApiEnabled);

      // Backend sends alot of extra data #Shocker, so we filter it out here given the data we sent them as the filter function
      return isMultiStoreEnabled ? backendResults : simplifyResult(bopisItems, backendResults);
    })
    .catch((err) => {
      logger.error(`Error in getBopisInventoryDetails API call: ${err}`);
      throw graphQlErrorHandler(err, errorsMapping);
    });
};

export default getBopisInventoryDetails;
